import { forwardRef } from "react";
function SvgRawWarningIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="#DD3636"
        fillRule="evenodd"
        stroke="#DD3636"
        strokeWidth={2}
        d="M11.096 3.908a1 1 0 0 1 1.808 0l7.42 15.664A1 1 0 0 1 19.42 21H4.58a1 1 0 0 1-.904-1.428l7.42-15.664Z"
        clipRule="evenodd"
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 17v.02M12 10v3"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawWarningIcon);
export default ForwardRef;
